import 'dayjs/locale/ru'
import 'moment/locale/ru'
import { Route, Routes } from 'react-router-dom'
import { LanguageInitializer } from './components/LanguageInitializer'
import { MainLayout } from './components/MainLayout'
import { PaymentRedirect } from './components/PaymentRedirect'
import { ProtectedRoute } from './components/ProtectedRoute/ProtectedRoute'
import { WebViewLayout } from './components/WebViewLayout'
import { WebViewRoute } from './components/WebViewRoute'
import {
    ASSISTANT_SHOP_ROUTE,
    ASSISTANT_USAGE_AGREEMENT_ROUTE,
    CALENDAR_ROUTE,
    DISK_ROUTE,
    FINANCES_ROUTE,
    FORGOT_PASSWORD_ROUTE,
    LOGIN_ROUTE,
    MEETS_ROUTE,
    NOTIFICATIONS_ROUTE,
    PERSONAL_DATA_AGREEMENT_ROUTE,
    PROFILE_ROUTE,
    PROJECT_ROUTE,
    RECORD_ROUTE,
    RECORDS_ROUTE,
    REFERRAL_PROGRAM_ROUTE,
    REQUEST_ROUTE,
    REQUESTS_ROUTE,
    ROOT_ROUTE,
    SETTING_ROUTE,
    SHARE_ROUTE,
    SIGN_UP_ROUTE,
    TERMS_OF_USE_ROUTE,
    USER_AGREEMENT_ROUTE,
    WEB_VIEW_ROUTE,
} from './constants/routing.constants'
import { LoginPage } from './pages/ExternalPage/LoginPage/LoginPage'
import { MemoStenographySharePage } from './pages/ExternalPage/MemoStenographySharePage/MemoStenographySharePage'
import SharedThreadPage from './pages/ExternalPage/SharedThreadPage/SharedThreadPage'
import { AssistantShopPage } from './pages/InternalPage/AssistantShopPage/AssistantShopPage'
import { AssistantsUsageAgreementPage } from './pages/InternalPage/AssistantsUsageAgreementPage/AssistantsUsageAgreementPage'
import { CalendarPage } from './pages/InternalPage/CalendarPage/CalendarPage'
import { DiskPage } from './pages/InternalPage/DiskPage/DiskPage'
import { ErrorPage } from './pages/InternalPage/ErrorPage/ErrorPage'
import { FinancesPage } from './pages/InternalPage/FinancesPage/FinancesPage'
import { MainPage } from './pages/InternalPage/MainPage/MainPage'
import { MeetsPage } from './pages/InternalPage/MeetPage/MeetsPage'
import { ModelSetupPage } from './pages/InternalPage/ModelSetupPage/ModelSetupPage'
import { NotificationsPage } from './pages/InternalPage/NotificationsPage/NotificationsPage'
import { PersonalDataAgreementPage } from './pages/InternalPage/PersonalDataAgreementPage/PersonalDataAgreementPage'
import { ProfilePage } from './pages/InternalPage/ProfilePage/ProfilePage'
import { ProjectArchivePage } from './pages/InternalPage/ProjectArchivePage/ProjectArchivePage'
import { ProjectPage } from './pages/InternalPage/ProjectPage/ProjectPage'
import { RecordDetailPage } from './pages/InternalPage/RecordDetailPage/RecordDetailPage'
import { RecordPage } from './pages/InternalPage/RecordsPage/RecordPage'
import { RecordUploadPage } from './pages/InternalPage/RecordUploadPage/RecordUploadPage'
import ReferralProgramPage from './pages/InternalPage/ReferralProgramPage/ReferralProgramPage'
import { RequestMessagesPage } from './pages/InternalPage/RequestMessagesPage/RequestMessagesPage'
import { RequestSettingPage } from './pages/InternalPage/RequestSettingPage/RequestSettingPage'
import { RequestPage } from './pages/InternalPage/RequestsPage/RequestPage'
import { TermsOfUsePage } from './pages/InternalPage/TermsOfUsePage/TermsOfUsePage'
import { UserAgreementPage } from './pages/InternalPage/UserAgreementPage/UserAgreementPage'
import { FinancesPage as WebViewFinancesPage } from './pages/WebViewPage/FinancesPage'
import { AssistantPayPage as WebViewAssistantPayPage } from './pages/WebViewPage/AssistantPayPage'
import { Providers } from './providers/Providers'
import { PaymentStatus } from './types/billing'

export default function App() {
    return (
        <Providers>
            <LanguageInitializer>
                <Routes>
                    <Route path={LOGIN_ROUTE} element={<LoginPage />} />
                    <Route path={SIGN_UP_ROUTE} element={<LoginPage />} />
                    <Route path={FORGOT_PASSWORD_ROUTE} element={<LoginPage />} />
                    <Route path={`${SHARE_ROUTE}/summary/`} element={<MemoStenographySharePage />} />
                    <Route path={`${SHARE_ROUTE}/thread/`} element={<SharedThreadPage />} />

                    <Route
                        element={
                            <ProtectedRoute>
                                <MainLayout />
                            </ProtectedRoute>
                        }>
                        <Route
                            path={ROOT_ROUTE}
                            element={
                                <ProtectedRoute>
                                    <MainPage />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path={REQUESTS_ROUTE}
                            element={
                                <ProtectedRoute>
                                    <RequestPage />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path={`${REQUEST_ROUTE}/:requestId`}
                            element={
                                <ProtectedRoute>
                                    <RequestMessagesPage />
                                </ProtectedRoute>
                            }
                        />

                        <Route path={PROJECT_ROUTE}>
                            <Route
                                index
                                element={
                                    <ProtectedRoute>
                                        <ProjectPage />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path=":projectId/setting"
                                element={
                                    <ProtectedRoute>
                                        <RequestSettingPage type="project" />
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="archive/:workplaceId"
                                element={
                                    <ProtectedRoute>
                                        <ProjectPage isWorkplaceArchived={true} />
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="archive"
                                element={
                                    <ProtectedRoute>
                                        <ProjectArchivePage />
                                    </ProtectedRoute>
                                }
                            />
                        </Route>

                        <Route path={RECORDS_ROUTE}>
                            <Route
                                index
                                element={
                                    <ProtectedRoute>
                                        <RecordPage />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="upload"
                                element={
                                    <ProtectedRoute>
                                        <RecordUploadPage />
                                    </ProtectedRoute>
                                }
                            />
                        </Route>

                        <Route
                            path={`${RECORD_ROUTE}/:recordId`}
                            element={
                                <ProtectedRoute>
                                    <RecordDetailPage recordId={':recordId'} />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path={SETTING_ROUTE}
                            element={
                                <ProtectedRoute>
                                    <ModelSetupPage />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path={MEETS_ROUTE}
                            element={
                                <ProtectedRoute>
                                    <MeetsPage />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path={CALENDAR_ROUTE}
                            element={
                                <ProtectedRoute>
                                    <CalendarPage />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path={DISK_ROUTE}
                            element={
                                <ProtectedRoute>
                                    <DiskPage />
                                </ProtectedRoute>
                            }
                        />

                        <Route path={FINANCES_ROUTE}>
                            <Route
                                index
                                element={
                                    <ProtectedRoute>
                                        <FinancesPage />
                                    </ProtectedRoute>
                                }
                            />
                        </Route>

                        <Route
                            path={PROFILE_ROUTE}
                            element={
                                <ProtectedRoute>
                                    <ProfilePage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={ASSISTANT_SHOP_ROUTE}
                            element={
                                <ProtectedRoute>
                                    <AssistantShopPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={REFERRAL_PROGRAM_ROUTE}
                            element={
                                <ProtectedRoute>
                                    <ReferralProgramPage />
                                </ProtectedRoute>
                            }
                        />

                        <Route path={TERMS_OF_USE_ROUTE}>
                            <Route
                                index
                                element={
                                    <ProtectedRoute>
                                        <TermsOfUsePage />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path={USER_AGREEMENT_ROUTE}
                                element={
                                    <ProtectedRoute>
                                        <UserAgreementPage />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path={ASSISTANT_USAGE_AGREEMENT_ROUTE}
                                element={
                                    <ProtectedRoute>
                                        <AssistantsUsageAgreementPage />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path={PERSONAL_DATA_AGREEMENT_ROUTE}
                                element={
                                    <ProtectedRoute>
                                        <PersonalDataAgreementPage />
                                    </ProtectedRoute>
                                }
                            />
                        </Route>

                        <Route
                            path={NOTIFICATIONS_ROUTE}
                            element={
                                <ProtectedRoute>
                                    <NotificationsPage />
                                </ProtectedRoute>
                            }
                        />
                    </Route>
                    <Route
                        path={`${FINANCES_ROUTE}/isPaymentSuccessful`}
                        element={<PaymentRedirect status={PaymentStatus.SUCCESS} />}
                    />
                    <Route
                        path={`${FINANCES_ROUTE}/isPaymentFailed`}
                        element={<PaymentRedirect status={PaymentStatus.ERROR} />}
                    />
                    <Route
                        path={WEB_VIEW_ROUTE}
                        element={
                            <WebViewRoute>
                                <WebViewLayout />
                            </WebViewRoute>
                        }>
                        <Route
                            path={`${WEB_VIEW_ROUTE}${FINANCES_ROUTE}`}
                            element={<WebViewFinancesPage />}
                        />
                        <Route
                            path={`${WEB_VIEW_ROUTE}/assistant-pay`}
                            element={<WebViewAssistantPayPage />}
                        />
                    </Route>

                    <Route path="*" element={<ErrorPage />} />
                </Routes>
            </LanguageInitializer>
        </Providers>
    )
}
